module.exports = __webpack_public_path__ + "static/BT-desktop-6-a8a08c4fd8252137efe7ff39e50a5e6b.jpg";